import {useAuthenticatedUser} from "hooks/useAuth";
import type {FC} from "react";
import {Navigate, useLocation} from "react-router";
import {getDefaultLandingPath, isPathAccessibleToUser} from "router/utils";

/**
 * Index route inside DashboardWrapper.
 * Preserves current URL if accessible to user, otherwise redirects to default landing page.
 *
 * NOTE: we assume authentication is handled elsewhere. This component only verifies
 * the user object exists and that the current path is accessible given admin-only gates.
 */
const RedirectToDefault: FC = () => {
  const user = useAuthenticatedUser();
  const location = useLocation();

  if (!user) {
    return <Navigate to="/" replace />;
  }

  // remove leading slash
  const currentPath = location.pathname.replace(/^\/+/, "");

  // If user is on a valid path, don't redirect
  if (currentPath && isPathAccessibleToUser(user, currentPath)) {
    return null;
  }

  // Otherwise, redirect to default landing page
  const path = getDefaultLandingPath(user);

  if (!path) {
    return <Navigate to="/forbidden" replace />;
  }

  return <Navigate to={`/${path}`} replace />;
};

export default RedirectToDefault;
